// HyperFormula is dual-licensed (GPL-v3 free / commercial paid). The
// 'gpl-v3' license key signals we accept the GPL terms — required at
// instance construction or HF logs warnings and may refuse to evaluate.
//
// @tinycld/calc is AGPL-v3, which is GPL-v3-compatible, so linking HF
// under its GPL-v3 hobby license is fine. Distributors of any binary
// containing this package must continue to satisfy the AGPL terms.
export const HYPERFORMULA_LICENSE_KEY = 'gpl-v3'
